/**
 * Swish Wishlist List View Toggle with Sorting & Filtering
 * Version: 1.2.0
 *
 * Adds list/grid view toggle, sorting, and in-stock filtering to Swish wishlist
 */

(function() {
  'use strict';

  var STORAGE_KEY = 'swish-wishlist-view-mode';
  var SORT_STORAGE_KEY = 'swish-wishlist-sort-order';
  var FILTER_STORAGE_KEY = 'swish-wishlist-in-stock-filter';
  var DEFAULT_VIEW = 'grid';
  var DEFAULT_SORT = 'date-added';
  var initAttempts = 0;
  var MAX_INIT_ATTEMPTS = 50;

  // Start initialization
  function tryInit() {
    initAttempts++;

    var wishlistPage = document.querySelector('wishlist-page');
    if (wishlistPage) {
      waitForWishlist(wishlistPage);
    } else {
      if (initAttempts < MAX_INIT_ATTEMPTS) {
        setTimeout(tryInit, 100);
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tryInit);
  } else {
    tryInit();
  }

  function waitForWishlist(wishlistPage) {
    if (wishlistPage.wishlist && wishlistPage.wishlist.items && wishlistPage.wishlist.items.length > 0) {
      // Wait a bit longer to ensure Swish has fully rendered the grid
      setTimeout(function() {
        // Double check that product cards are actually rendered
        var productCards = document.querySelectorAll('wishlist-product-card .wk-product-card');
        if (productCards.length > 0) {
          setupListView(wishlistPage);
        } else {
          // If cards aren't ready, wait longer
          setTimeout(function() {
            setupListView(wishlistPage);
          }, 200);
        }
      }, 150);
    } else {
      setTimeout(function() {
        waitForWishlist(wishlistPage);
      }, 100);
    }
  }

  function setupListView(wishlistPage) {
    // Check for development key in URL
    var urlParams = new URLSearchParams(window.location.search);
    var devKey = urlParams.get('devkey');
    if (devKey !== 'f23htr') {
        // disable restriction
        // return;
    }

    var wishlistGrid = document.querySelector('.wk-grid');
    if (!wishlistGrid) return;

    addControlsBar(wishlistGrid);

    // Get saved preferences
    var savedMode = localStorage.getItem(STORAGE_KEY) || DEFAULT_VIEW;
    var savedSort = localStorage.getItem(SORT_STORAGE_KEY) || DEFAULT_SORT;
    var savedFilter = localStorage.getItem(FILTER_STORAGE_KEY) === 'true';

    // If saved mode is list, enhance cards first, THEN switch to list view
    if (savedMode === 'list') {
      // Enhance all cards for list view
      var productCards = document.querySelectorAll('wishlist-product-card');
      for (var i = 0; i < productCards.length; i++) {
        enhanceProductCard(productCards[i]);
      }

      // Now it's safe to apply list view
      setTimeout(function() {
        applyViewMode('list', wishlistGrid);
        
        // AFTER view mode is applied, then apply sorting and filtering
        setTimeout(function() {
          applySorting(savedSort);
          if (savedFilter) {
            applyInStockFilter(true);
          }
        }, 100);
      }, 200);
    } else {
      // Grid view - apply sorting and filtering immediately
      applySorting(savedSort);
      if (savedFilter) {
        applyInStockFilter(true);
      }
    }

    observeWishlistChanges(wishlistGrid);
  }

  function addControlsBar(wishlistGrid) {
    if (document.querySelector('.wk-controls-bar')) return;

    var controlsBar = document.createElement('div');
    controlsBar.className = 'wk-controls-bar';

    // Left side: View toggle buttons
    var toggleContainer = document.createElement('div');
    toggleContainer.className = 'wk-view-toggle';

    toggleContainer.innerHTML = '<button type="button" class="wk-view-toggle-btn active" data-view="grid" aria-label="Grid view" title="Grid view">' +
      '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">' +
      '<rect x="3" y="3" width="7" height="7" stroke="currentColor" stroke-width="2"/>' +
      '<rect x="14" y="3" width="7" height="7" stroke="currentColor" stroke-width="2"/>' +
      '<rect x="3" y="14" width="7" height="7" stroke="currentColor" stroke-width="2"/>' +
      '<rect x="14" y="14" width="7" height="7" stroke="currentColor" stroke-width="2"/>' +
      '</svg></button>' +
      '<button type="button" class="wk-view-toggle-btn" data-view="list" aria-label="List view" title="List view">' +
      '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">' +
      '<line x1="3" y1="6" x2="21" y2="6" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>' +
      '<line x1="3" y1="12" x2="21" y2="12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>' +
      '<line x1="3" y1="18" x2="21" y2="18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>' +
      '</svg></button>';

    // Right side: Filter and Sort controls
    var filterSortContainer = document.createElement('div');
    filterSortContainer.className = 'wk-filter-sort-controls';

    // In Stock checkbox
    var savedFilter = localStorage.getItem(FILTER_STORAGE_KEY) === 'true';
    filterSortContainer.innerHTML = '<div class="wk-in-stock-filter">' +
      '<label class="wk-in-stock-label">' +
      '<input type="checkbox" class="wk-in-stock-checkbox" ' + (savedFilter ? 'checked' : '') + '>' +
      '<span>In Stock Only</span>' +
      '</label>' +
      '</div>' +
      '<div class="facet-filters sorting caption">' +
      '<div class="facet-filters__field">' +
      '<h2 class="facet-filters__label caption-large text-body">' +
      '<label for="WishlistSortBy">Sort by:</label>' +
      '</h2>' +
      '<div class="select">' +
      '<select name="sort_by" class="facet-filters__sort select__select caption-large" id="WishlistSortBy">' +
      '<option value="date-added">Date Added (Newest First)</option>' +
      '<option value="title-asc">Alphabetically, A-Z</option>' +
      '<option value="title-desc">Alphabetically, Z-A</option>' +
      '<option value="price-asc">Price, Low to High</option>' +
      '<option value="price-desc">Price, High to Low</option>' +
      '<option value="type-asc">Product Category</option>' +
      '</select>' +
      '<span class="svg-wrapper">' +
      '<svg class="icon icon-caret" viewBox="0 0 10 6">' +
      '<path fill="currentColor" fill-rule="evenodd" d="M9.354.646a.5.5 0 0 0-.708 0L5 4.293 1.354.646a.5.5 0 0 0-.708.708l4 4a.5.5 0 0 0 .708 0l4-4a.5.5 0 0 0 0-.708" clip-rule="evenodd"></path>' +
      '</svg>' +
      '</span>' +
      '</div>' +
      '</div>' +
      '</div>';

    // Assemble controls bar
    controlsBar.appendChild(toggleContainer);
    controlsBar.appendChild(filterSortContainer);

    wishlistGrid.parentNode.insertBefore(controlsBar, wishlistGrid);

    // Set saved sort value
    var savedSort = localStorage.getItem(SORT_STORAGE_KEY) || DEFAULT_SORT;
    var sortSelect = document.getElementById('WishlistSortBy');
    if (sortSelect) {
      sortSelect.value = savedSort;
    }

    // Attach event listeners
    var toggleButtons = toggleContainer.querySelectorAll('.wk-view-toggle-btn');
    for (var i = 0; i < toggleButtons.length; i++) {
      toggleButtons[i].addEventListener('click', handleToggleClick);
    }

    var inStockCheckbox = filterSortContainer.querySelector('.wk-in-stock-checkbox');
    if (inStockCheckbox) {
      inStockCheckbox.addEventListener('change', handleInStockFilter);
    }

    if (sortSelect) {
      sortSelect.addEventListener('change', handleSortChange);
    }
  }

  function handleToggleClick(event) {
    var btn = event.currentTarget;
    var viewMode = btn.dataset.view;
    var wishlistGrid = document.querySelector('.wk-grid');

    var allButtons = document.querySelectorAll('.wk-view-toggle-btn');
    for (var i = 0; i < allButtons.length; i++) {
      if (allButtons[i] === btn) {
        allButtons[i].classList.add('active');
      } else {
        allButtons[i].classList.remove('active');
      }
    }

    applyViewMode(viewMode, wishlistGrid);
    localStorage.setItem(STORAGE_KEY, viewMode);
  }

  function handleSortChange(event) {
    var sortOrder = event.target.value;
    localStorage.setItem(SORT_STORAGE_KEY, sortOrder);
    applySorting(sortOrder);
  }

  function handleInStockFilter(event) {
    var isChecked = event.target.checked;
    localStorage.setItem(FILTER_STORAGE_KEY, isChecked);
    applyInStockFilter(isChecked);
  }

  function applySorting(sortOrder) {
    var wishlistGrid = document.querySelector('.wk-grid');
    if (!wishlistGrid) return;

    var productCards = Array.prototype.slice.call(wishlistGrid.querySelectorAll('wishlist-product-card'));
    
    // Store original order if not already stored
    if (!wishlistGrid._originalOrder) {
      wishlistGrid._originalOrder = productCards.map(function(card) {
        return card;
      });
    }

    var sortedCards;

    switch (sortOrder) {
      case 'title-asc':
        sortedCards = sortByTitle(productCards, true);
        break;
      case 'title-desc':
        sortedCards = sortByTitle(productCards, false);
        break;
      case 'price-asc':
        sortedCards = sortByPrice(productCards, true);
        break;
      case 'price-desc':
        sortedCards = sortByPrice(productCards, false);
        break;
      case 'type-asc':
        sortedCards = sortByType(productCards);
        break;
      case 'date-added':
      default:
        // Restore original order
        sortedCards = wishlistGrid._originalOrder.slice();
        break;
    }

    // Reorder DOM elements
    for (var i = 0; i < sortedCards.length; i++) {
      wishlistGrid.appendChild(sortedCards[i]);
    }
  }

  function sortByTitle(cards, ascending) {
    return cards.slice().sort(function(a, b) {
      var titleA = getProductTitle(a).toLowerCase();
      var titleB = getProductTitle(b).toLowerCase();
      
      if (titleA < titleB) return ascending ? -1 : 1;
      if (titleA > titleB) return ascending ? 1 : -1;
      return 0;
    });
  }

  function sortByPrice(cards, ascending) {
    return cards.slice().sort(function(a, b) {
      var priceA = getNMPrice(a);
      var priceB = getNMPrice(b);
      
      return ascending ? priceA - priceB : priceB - priceA;
    });
  }

  function sortByType(cards) {
    return cards.slice().sort(function(a, b) {
      var typeA = getProductType(a).toLowerCase();
      var typeB = getProductType(b).toLowerCase();
      
      if (typeA < typeB) return -1;
      if (typeA > typeB) return 1;
      return 0;
    });
  }

  function applyInStockFilter(showInStockOnly) {
    var productCards = document.querySelectorAll('wishlist-product-card');

    for (var i = 0; i < productCards.length; i++) {
      var card = productCards[i];
      var hasStock = checkIfAnyVariantInStock(card);

      if (showInStockOnly && !hasStock) {
        card.style.display = 'none';
      } else {
        card.style.display = '';
      }
    }
  }

  function checkIfAnyVariantInStock(card) {
    if (!card.wishlistItem || !card.wishlistItem.product) return false;
    
    var product = card.wishlistItem.product;
    for (var i = 0; i < product.variants.length; i++) {
      if (product.variants[i].available) {
        return true;
      }
    }
    return false;
  }

  function getProductTitle(card) {
    if (!card.wishlistItem || !card.wishlistItem.product) return '';
    return card.wishlistItem.product.title || '';
  }

  function getNMPrice(card) {
    if (!card.wishlistItem || !card.wishlistItem.product) return Infinity;
    
    var product = card.wishlistItem.product;
    
    // Look for NM variant first
    for (var i = 0; i < product.variants.length; i++) {
      var variant = product.variants[i];
      var title = variant.title || '';
      if (title.indexOf('NM') === 0 || title.indexOf('Near Mint') !== -1) {
        return variant.price || Infinity;
      }
    }
    
    // Fallback to first variant price
    if (product.variants.length > 0) {
      return product.variants[0].price || Infinity;
    }
    
    return Infinity;
  }

  function getProductType(card) {
    if (!card.wishlistItem || !card.wishlistItem.product) return '';
    
    var productType = card.wishlistItem.product.type || '';
    
    // Extract last segment after final ">"
    var segments = productType.split('>');
    if (segments.length > 0) {
      return segments[segments.length - 1].trim();
    }
    
    return productType;
  }

  function applyViewMode(mode, wishlistGrid) {
    if (mode === 'list') {
      wishlistGrid.classList.add('list-view');
      enhanceForListView();

      var allButtons = document.querySelectorAll('.wk-view-toggle-btn');
      for (var i = 0; i < allButtons.length; i++) {
        if (allButtons[i].dataset.view === 'list') {
          allButtons[i].classList.add('active');
        } else {
          allButtons[i].classList.remove('active');
        }
      }
    } else {
      wishlistGrid.classList.remove('list-view');
      restoreGridView();

      var allButtons = document.querySelectorAll('.wk-view-toggle-btn');
      for (var i = 0; i < allButtons.length; i++) {
        if (allButtons[i].dataset.view === 'grid') {
          allButtons[i].classList.add('active');
        } else {
          allButtons[i].classList.remove('active');
        }
      }
    }
  }

  function enhanceForListView() {
    var productCards = document.querySelectorAll('wishlist-product-card');

    for (var i = 0; i < productCards.length; i++) {
      var card = productCards[i];

      // Enhance if not already done
      if (!card._listViewEnhanced) {
        enhanceProductCard(card);
        continue;
      }

      // Show list view, hide grid view
      if (card._listViewContainer && card._gridViewContainer) {
        card._gridViewContainer.style.display = 'none';
        card._listViewContainer.style.display = 'flex';
        attachListViewEventListeners(card);
      }
    }
  }

  function restoreGridView() {
    var productCards = document.querySelectorAll('wishlist-product-card');

    for (var i = 0; i < productCards.length; i++) {
      var card = productCards[i];

      // Show grid view, hide list view
      if (card._listViewContainer && card._gridViewContainer) {
        card._listViewContainer.style.display = 'none';
        card._gridViewContainer.style.display = '';
      }
    }
  }

  function enhanceProductCard(card) {
    // Skip if already enhanced
    if (card._listViewEnhanced) {
      return;
    }

    var wishlistItem = card.wishlistItem;
    if (!wishlistItem || !wishlistItem.product) return;

    var product = wishlistItem.product;
    var cardWrapper = card.querySelector('.wk-product-card');
    if (!cardWrapper) return;

    // Get current variant (with smart fallback to best available)
    var currentVariant = getCurrentVariant(wishlistItem, product);

    // Create a separate container for list view
    var listViewContainer = document.createElement('div');
    listViewContainer.className = 'wk-product-card wk-list-view-content';
    listViewContainer.style.display = 'none';
    listViewContainer.innerHTML = createListViewContent(product, currentVariant, card);

    // Add list view container as sibling to grid view
    cardWrapper.parentNode.insertBefore(listViewContainer, cardWrapper.nextSibling);

    // Store reference
    card._listViewContainer = listViewContainer;
    card._gridViewContainer = cardWrapper;

    // Mark as enhanced
    card._listViewEnhanced = true;

    // Check if we should show list view now
    var wishlistGrid = document.querySelector('.wk-grid');
    if (wishlistGrid && wishlistGrid.classList.contains('list-view')) {
      cardWrapper.style.display = 'none';
      listViewContainer.style.display = 'flex';
      attachListViewEventListeners(card);
    }
  }

  // Helper function to clean duplicate SVGs from Swish's web components
  function cleanDuplicateSVGs(container) {
    var icons = container.querySelectorAll('wk-icon');
    for (var i = 0; i < icons.length; i++) {
      var svgs = icons[i].querySelectorAll('svg');
      // Keep only the first SVG, remove duplicates
      for (var j = 1; j < svgs.length; j++) {
        svgs[j].remove();
      }
    }
  }

  function getCurrentVariant(wishlistItem, product) {
    var variantId = wishlistItem.variantId;
    var savedVariant = null;

    // Find the saved variant
    for (var i = 0; i < product.variants.length; i++) {
      if (product.variants[i].id == variantId) {
        savedVariant = product.variants[i];
        break;
      }
    }

    // If saved variant is available, use it
    if (savedVariant && savedVariant.available) {
      return savedVariant;
    }

    // Otherwise, find best available condition in priority order: NM > SP > MP > HP
    var conditionPriority = ['NM', 'SP', 'MP', 'HP'];
    for (var j = 0; j < conditionPriority.length; j++) {
      var condition = conditionPriority[j];
      for (var k = 0; k < product.variants.length; k++) {
        var variant = product.variants[k];
        var variantTitle = variant.title || '';
        // Check if variant starts with this condition
        if (variantTitle.indexOf(condition) === 0 && variant.available) {
          return variant;
        }
      }
    }

    // If no available variants, return the saved variant (or first variant)
    return savedVariant || product.variants[0];
  }

  function createListViewContent(product, currentVariant, card) {
    var moveToCart = card.hasAttribute('move-to-cart');
    var productUrl = product.url || '#';
    var productTitle = escapeHtml(product.title || 'Untitled Product');
    
    // Get image from multiple possible sources
    var productImage = '';
    if (product.featuredImage && product.featuredImage.url) {
      productImage = product.featuredImage.url;
    } else if (product.featuredImage && typeof product.featuredImage === 'string') {
      productImage = product.featuredImage;
    } else if (product.image) {
      productImage = product.image;
    } else {
      // Fallback: try to get from grid view img
      var gridImg = card.querySelector('.wk-product-card img');
      if (gridImg && gridImg.src) {
        productImage = gridImg.src;
      }
    }

    // Extract last segment of product type
    var productType = product.type || '';
    var typeSegments = productType.split('>');
    var displayType = typeSegments.length > 0 ? typeSegments[typeSegments.length - 1].trim() : productType;

    var stockStatus = getStockStatus(currentVariant);

    // Check if this is a single-variant product (non-variant product)
    var isSingleVariant = product.variants.length === 1 && 
                          (product.variants[0].title === 'Default Title' || 
                           product.variants[0].title === product.title);

    var variantSelectorHtml = '';
    var priceDisplayHtml = '';

    if (isSingleVariant) {
      // For single-variant products, show price display like grid view
      var variant = product.variants[0];
      var currentPrice = formatPrice(variant.price);
      
      // Check multiple possible property names for compare price
      var compareAtPrice = variant.compareAtPrice || variant.compare_at_price || variant.comparePrice;
      var comparePrice = compareAtPrice ? formatPrice(compareAtPrice) : null;
      
      if (comparePrice && comparePrice !== currentPrice && compareAtPrice > variant.price) {
        // On sale
        priceDisplayHtml = '<div class="wk-price">' +
          '<span class="wk-compare-price">' + comparePrice + '</span>' +
          '<span class="wk-current-price wk-sale">' + currentPrice + '</span>' +
          '</div>';
      } else {
        // Regular price
        priceDisplayHtml = '<div class="wk-price">' +
          '<span class="wk-current-price">' + currentPrice + '</span>' +
          '</div>';
      }
    } else {
      // For multi-variant products, show dropdown
      var variantOptionsHtml = '';
      for (var i = 0; i < product.variants.length; i++) {
        var variant = product.variants[i];
        var isSelected = variant.id == currentVariant.id;
        var isDisabled = !variant.available;
        var variantPrice = formatPrice(variant.price);
        
        // Check multiple possible property names for compare price
        var compareAtPrice = variant.compareAtPrice || variant.compare_at_price || variant.comparePrice;
        var comparePrice = compareAtPrice ? formatPrice(compareAtPrice) : null;
        
        // Build price display - can't use HTML in option tags, use plain text
        var priceText = '';
        if (comparePrice && comparePrice !== variantPrice && compareAtPrice > variant.price) {
          // Show both prices with "was" indicator
          priceText = 'Was ' + comparePrice + ', Now ' + variantPrice;
        } else {
          priceText = variantPrice;
        }

        variantOptionsHtml += '<option value="' + variant.id + '"' +
          (isSelected ? ' selected' : '') +
          (isDisabled ? ' disabled' : '') +
          '>' + escapeHtml(variant.title) + ' - ' + priceText +
          (isDisabled ? ' (Out of Stock)' : '') +
          '</option>';
      }

      var outOfStockClass = (!currentVariant || !currentVariant.available) ? ' out-of-stock-selected' : '';
      
      variantSelectorHtml = '<select class="wk-variant-select' + outOfStockClass + '" data-variant-selector>' +
        variantOptionsHtml +
        '</select>';
    }

    var addToCartDisabled = !currentVariant || !currentVariant.available;

    return '<div class="card__media">' +
      '<a href="' + productUrl + '">' +
      '<img src="' + productImage + '" alt="' + productTitle + '">' +
      '</a>' +
      '</div>' +
      '<div class="card__content">' +
      '<h3 class="card__heading">' +
      '<a href="' + productUrl + '">' + productTitle + '</a>' +
      '</h3>' +
      '<div class="wk-product-info">' +
      '<div class="product-type">' + escapeHtml(displayType) + '</div>' +
      '<div class="wk-list-actions">' +
      (variantSelectorHtml || priceDisplayHtml) +
      '<span class="swish-list-stock-indicator ' + stockStatus.className + '">' +
      stockStatus.text +
      '</span>' +
      '<div class="wk-quantity-input">' +
      '<button type="button" class="wk-quantity-btn" data-quantity-decrease>−</button>' +
      '<span class="wk-quantity-value" data-quantity-value>1</span>' +
      '<button type="button" class="wk-quantity-btn" data-quantity-increase>+</button>' +
      '</div>' +
      '<button type="button" class="wk-add-to-cart-btn" data-add-to-cart' +
      (addToCartDisabled ? ' disabled' : '') + '>' +
      (moveToCart ? 'Move to Cart' : 'Add to Cart') +
      '</button>' +
      '<button type="button" class="wk-remove-btn" data-remove-item>Remove</button>' +
      '</div>' +
      '</div>' +
      '</div>';
  }

  function attachListViewEventListeners(card) {
    var listView = card._listViewContainer;
    if (!listView) return;

    // Remove existing listeners by cloning
    var newListView = listView.cloneNode(true);
    listView.parentNode.replaceChild(newListView, listView);
    card._listViewContainer = newListView;

    // Quantity buttons
    var decreaseBtn = newListView.querySelector('[data-quantity-decrease]');
    var increaseBtn = newListView.querySelector('[data-quantity-increase]');

    if (decreaseBtn) {
      decreaseBtn.addEventListener('click', function() {
        updateQuantity(card, -1);
      });
    }

    if (increaseBtn) {
      increaseBtn.addEventListener('click', function() {
        updateQuantity(card, 1);
      });
    }

    // Add to cart button
    var addToCartBtn = newListView.querySelector('[data-add-to-cart]');
    if (addToCartBtn) {
      addToCartBtn.addEventListener('click', function() {
        handleAddToCart(card);
      });
    }

    // Remove button
    var removeBtn = newListView.querySelector('[data-remove-item]');
    if (removeBtn) {
      removeBtn.addEventListener('click', function() {
        handleRemoveItem(card);
      });
    }

    // Variant selector
    var variantSelector = newListView.querySelector('[data-variant-selector]');
    if (variantSelector) {
      variantSelector.addEventListener('change', function(event) {
        handleVariantChange(card, event);
      });
    }
  }

  function handleVariantChange(card, event) {
    var variantId = event.target.value;
    var product = card.wishlistItem.product;

    // Find selected variant
    var selectedVariant = null;
    for (var i = 0; i < product.variants.length; i++) {
      if (product.variants[i].id == variantId) {
        selectedVariant = product.variants[i];
        break;
      }
    }

    if (selectedVariant) {
      // Update stock indicator
      var stockIndicator = card._listViewContainer.querySelector('.swish-list-stock-indicator');
      if (stockIndicator) {
        var stockStatus = getStockStatus(selectedVariant);
        stockIndicator.className = 'swish-list-stock-indicator ' + stockStatus.className;
        stockIndicator.textContent = stockStatus.text;
      }

      // Update add to cart button state
      var addToCartBtn = card._listViewContainer.querySelector('[data-add-to-cart]');
      if (addToCartBtn) {
        addToCartBtn.disabled = !selectedVariant.available;
      }

      // Update variant selector styling based on stock
      var variantSelector = event.target;
      if (selectedVariant.available) {
        variantSelector.classList.remove('out-of-stock-selected');
      } else {
        variantSelector.classList.add('out-of-stock-selected');
      }

      // Update Swish's internal variantId
      card.wishlistItem.variantId = parseInt(variantId);

      // Update Swish's native dropdown to trigger auto-save
      var swishSelect = card.querySelector('wk-option-select select');
      if (swishSelect) {
        // Swish uses the condition name as the value, not variant ID
        // Find the option that matches our selected variant's title
        var conditionName = selectedVariant.title; // e.g., "SP - Slightly Played"
        swishSelect.value = conditionName;

        // Trigger change event so Swish saves it
        var changeEvent = new Event('change', { bubbles: true });
        swishSelect.dispatchEvent(changeEvent);
      }
    }
  }

  function updateQuantity(card, delta) {
    var quantityValue = card.querySelector('[data-quantity-value]');
    if (!quantityValue) return;

    var currentQty = parseInt(quantityValue.textContent) || 1;
    var newQty = Math.max(1, currentQty + delta);

    quantityValue.textContent = newQty;
  }

  function handleAddToCart(card) {
    var addToCartBtn = card.querySelector('[data-add-to-cart]');
    var variantSelector = card.querySelector('[data-variant-selector]');
    var quantityValue = card.querySelector('[data-quantity-value]');

    var variantId = card.wishlistItem.variantId;
    if (variantSelector && variantSelector.value) {
      variantId = parseInt(variantSelector.value);
    }

    var quantity = quantityValue ? parseInt(quantityValue.textContent) : 1;

    if (!variantId) {
      showToast('Please select a variant', 'error');
      return;
    }

    // Check if variant is available
    var product = card.wishlistItem.product;
    var selectedVariant = null;
    for (var i = 0; i < product.variants.length; i++) {
      if (product.variants[i].id == variantId) {
        selectedVariant = product.variants[i];
        break;
      }
    }

    if (!selectedVariant || !selectedVariant.available) {
      showToast('This item is out of stock', 'error');
      return;
    }

    if (addToCartBtn) {
      addToCartBtn.disabled = true;
      addToCartBtn.textContent = 'Adding...';
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: variantId,
        quantity: quantity
      })
    })
    .then(function(response) {
      if (!response.ok) {
        throw new Error('Cart add failed');
      }
      return response.json();
    })
    .then(function() {
      return updateCartBubble();
    })
    .then(function() {
      showToast('Item added to cart');

      if (card.hasAttribute('move-to-cart') && card.app) {
        return card.app.removeWishlistItem({
          wishlistItemId: card.wishlistItem.id
        });
      }
    })
    .then(function() {
      if (quantityValue) {
        quantityValue.textContent = '1';
      }
    })
    .catch(function(error) {
      console.error('Error adding to cart:', error);
      showToast('Error adding to cart', 'error');
    })
    .finally(function() {
      if (addToCartBtn) {
        addToCartBtn.disabled = !selectedVariant.available;
        var moveToCart = card.hasAttribute('move-to-cart');
        addToCartBtn.textContent = moveToCart ? 'Move to Cart' : 'Add to Cart';
      }
    });
  }

  function handleRemoveItem(card) {
    var removeBtn = card.querySelector('[data-remove-item]');

    if (removeBtn) {
      removeBtn.disabled = true;
      removeBtn.textContent = 'Removing...';
    }

    if (card.app && card.wishlistItem) {
      card.app.removeWishlistItem({
        wishlistItemId: card.wishlistItem.id
      })
      .then(function() {
        // Successfully removed - hide the card with a fade out effect
        card.style.transition = 'opacity 0.3s ease';
        card.style.opacity = '0';
        
        setTimeout(function() {
          // Remove the card from DOM after fade
          if (card.parentNode) {
            card.parentNode.removeChild(card);
          }
        }, 300);
      })
      .catch(function(error) {
        console.error('Error removing item:', error);
        if (removeBtn) {
          removeBtn.disabled = false;
          removeBtn.textContent = 'Remove';
        }
      });
    }
  }

  function getStockStatus(variant) {
    if (!variant) {
      return { className: 'out-of-stock', text: 'Out of Stock' };
    }

    if (variant.available) {
      return { className: 'in-stock', text: 'In Stock' };
    } else {
      return { className: 'out-of-stock', text: 'Out of Stock' };
    }
  }

  function formatPrice(priceInCents) {
    return '$' + (priceInCents / 100).toFixed(2);
  }

  function escapeHtml(text) {
    var div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
  }

  function updateCartBubble() {
    return fetch('/cart.js')
      .then(function(response) {
        return response.json();
      })
      .then(function(currentCart) {
        var cartIcon = document.querySelector('#cart-icon-bubble');
        if (cartIcon) {
          var cartBubble = cartIcon.querySelector('.cart-count-bubble');

          if (!cartBubble) {
            cartBubble = document.createElement('div');
            cartBubble.className = 'cart-count-bubble';
            cartBubble.innerHTML = '<span aria-hidden="true"></span><span class="visually-hidden"> items</span>';
            cartIcon.appendChild(cartBubble);
          }

          var countSpan = cartBubble.querySelector('span[aria-hidden="true"]');
          var visuallyHiddenSpan = cartBubble.querySelector('.visually-hidden');
          if (countSpan) {
            countSpan.textContent = currentCart.item_count;
          }
          if (visuallyHiddenSpan) {
            visuallyHiddenSpan.textContent = currentCart.item_count + ' items';
          }

          cartBubble.classList.remove('hidden');
          cartBubble.style.display = '';
        }
      })
      .catch(function(error) {
        console.error('Error updating cart count:', error);
      });
  }

  function showToast(message, type, duration) {
    type = type || 'success';
    duration = duration || 3000;

    var toast = document.createElement('div');
    toast.className = 'swish-toast';

    var messageText = document.createElement('div');
    messageText.textContent = message;

    var cartLink = document.createElement('a');
    cartLink.href = '/cart';
    cartLink.className = 'swish-toast-link';
    cartLink.textContent = '(View Cart)';

    toast.appendChild(messageText);
    if (type === 'success') {
      toast.appendChild(cartLink);
    }

    document.body.appendChild(toast);

    setTimeout(function() {
      toast.classList.add('show');
    }, 10);

    setTimeout(function() {
      toast.classList.remove('show');
      setTimeout(function() {
        toast.remove();
      }, 300);
    }, duration);
  }

  function observeWishlistChanges(wishlistGrid) {
    var observer = new MutationObserver(function(mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var addedNodes = mutations[i].addedNodes;
        for (var j = 0; j < addedNodes.length; j++) {
          if (addedNodes[j].tagName === 'WISHLIST-PRODUCT-CARD') {
            if (wishlistGrid.classList.contains('list-view')) {
              enhanceProductCard(addedNodes[j]);
            }
          }
        }
      }
    });

    observer.observe(wishlistGrid, { childList: true });
  }

})();